$('.main-slides').slick({
  dots: true,
  infinite: true,
  arrows: false,
  speed: 700,
  slidesToShow: 3,
  slidesToScroll: 1,
  speed: 500,
  autoplay: false,
  autoplaySpeed: 2000,
  cssEase: 'ease-in-out', 
  centerMode: true,
  pauseOnHover: false,
  centerPadding: '0px',
  // adaptiveHeight: true,
  responsive: [    
    {
      breakpoint: 968,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '100px',
      }
    },
  ]
});

$('.main-testimonial-slides').slick({
  dots: false,
  infinite: true,
  arrows: false,
  slidesToShow:3,
  slidesToScroll: 1,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2000,
  cssEase: 'ease-in-out',
  centerPadding: '0px',
  centerMode: true,
  pauseOnHover: false,
  responsive: [    
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerPadding: '50px',
      }
    },
  ]
});

$('.main-review-slides').slick({
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000, 
  cssEase: 'ease-in-out', 
  responsive: [    
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        
      }
    },
  ]
});

$('.main-dialogue-slides').slick({
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000, 
  cssEase: 'ease-in-out', 
  responsive: [    
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
  ]
});
$('.main-recomm-slides').slick({
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 4,
  slidesToScroll: 1,
  cssEase: 'ease-in-out', 
  responsive: [    
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
  ]
});